import DTSecurityImage from '../images/DTSecurity.jpg';
import BroadmeadowsImage from '../images/BroadmeadowsPlaceMedicalCentre.jpg';
import InsuranceImage from '../images/IntergratedInsuranceSolutions.png';
import DigitalImages from '../images/DigitalCrafters.png';
import TSSImage from '../images/TSS.png';
import FizzBuzzImage from '../images/FizzBuzz.png';

import FigmaLogo from '../images/figma-logo.png';
import NextLogo from '../images/nextjs-logo.png';
import GitLogo from '../images/git-logo.png';
import GithubLogo from '../images/github-logo.png';
import PostmanLogo from '../images/postman-logo.png';
import ExpressLogo from '../images/express-js-logo.png';
import FirebaseLogo from '../images/firebase-logo.webp';
import CssLogo from '../images/css-logo.webp';
import HtmlLogo from '../images/html-logo.webp';
import TypeScriptLogo from '../images/typescript-logo.png';
import NetLogo from '../images/NET_Logo.png'
import CLogo from '../images/c_icon.png'
import MongodbLogo from '../images/mongodb_logo.webp'
import TailwindLogo from '../images/tailwind-logo.png'

export const Bio = {
  name: "Tommy Bui",
  roles: ["Full Stack Developer", "Software Engineer"],
  description:
    "I am a passionate Software Engineer with hands-on experience in building and developing innovative applications. Skilled in full-stack development, with a strong foundation in React.js, Next.js, TypeScript, and .NET. Dedicated to crafting efficient, reliable, and secure software solutions while continuously refining my expertise to create impactful and scalable applications.",
  github: "https://github.com/TommyBui89",
  resume:
    "https://drive.google.com/file/d/1K3-Iz58icS1p31QReCg2wHSrLtYtDVgh/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/tommy-bui-0b242124b/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next Js",
        image: NextLogo,
      },
      {
        name: "HTML",
        image: HtmlLogo,
      },
      {
        name: "CSS",
        image: CssLogo,
      },
      {
        name: "JavaScript",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "TypeScript",
        image: TypeScriptLogo,
      },
      {
        name: "Bootstrap",
        image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Tailwind",
        image: TailwindLogo,
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image: ExpressLogo,
      },
      {
        name: ".Net",
        image: NetLogo,
      },
      {
        name: "C#",
        image: CLogo,
      },
      {
        name: "Python",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image: MongodbLogo,
      },
      {
        name: "Firebase",
        image: FirebaseLogo,
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: GitLogo,
      },
      {
        name: "GitHub",
        image: GithubLogo,
      },
      {
        name: "Docker",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "VS Code",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image: PostmanLogo,
      },
      {
        name: "Figma",
        image: FigmaLogo,
      },
    ],
  },
];

export const experiences = [
  {
    title: "Software Developer Volunteer",
    subtitle: "ASRC (Asylum Seeker Resource Centre)",
    date: "June 2024 - December 2024",
    description: [
      "Collaborated with the ICT Manager to enhance ASRC’s website, improving accessibility and user experience.",
      "Optimized website performance, increasing page load speed from 61% to 91%.",
    ],
    skills: ["Web Development", "Performance Optimization", "Accessibility"],
    type: "work",
  },
  {
    title: "Freelance Full Stack Developer",
    subtitle: "Freelance",
    date: "October 2023 - Present",
    description: [
      "Designed and developed client websites using React.js, Next.js, TypeScript, .NET, C#, and Node.js.",
      "Built RESTful APIs and integrated backend services to optimize data management.",
      "Improved site reliability by reducing website load times by 30% through performance enhancements and bug fixes.",
    ],
    skills: ["React.js", "Next.js", "TypeScript", ".NET", "C#", "Node.js", "Web Performance"],
    type: "work",
  },
  {
    title: "Software Developer",
    subtitle: "Spectar Group",
    date: "August 2023 - December 2023",
    description: [
      "Led front-end development for Specia, a virtual recruitment platform, improving process efficiency by 30% and user engagement by 40%.",
      "Built reusable UI components, reducing development time by 25%.",
      "Optimized app performance, cutting load times by 35%.",
      "Deployed on Azure Cloud with 99.9% uptime.",
    ],
    skills: ["React.js", "Next.js", "TypeScript", "Azure", "Performance Optimization"],
    type: "work",
  },
  {
    title: "Front-End Developer",
    subtitle: "IT Boost Australia",
    date: "May 2023 - August 2023",
    description: [
      "Developed and maintained client websites using React.js, HTML, and CSS.",
      "Partnered with backend developers to enhance UI/UX, reducing bounce rates by 15%.",
      "Improved site speed by 30% by optimizing assets and resolving bugs.",
    ],
    skills: ["React.js", "HTML", "CSS", "UI/UX"],
    type: "work",
  },
  {
    title: "Bachelor of Computer Science in Software Engineering",
    subtitle: "La Trobe University, Melbourne",
    date: "March 2021 - November 2023",
    description: [
      "Completed a Bachelor's degree in Computer Science with a focus on Software Engineering.",
      "Gained hands-on experience in front-end and back-end development, database systems, and software engineering best practices.",
      "Member of the Computer Science Student Society.",
    ],
    skills: ["Software Engineering", "Database Systems", "Front-End Development", "Back-End Development"],
    type: "education",
  },
];


export const projects = [
  {
    id: 0,
    title: "Talent Spree Solutions",
    date: "January 2025 – March 2025",
    description:
      "Built a full-stack recruitment platform with a Next.js frontend and .NET Core backend. Implemented a custom CRM to manage job listings and applications, with real-time status updates and data handling via RESTful APIs and MongoDB.",
    image: TSSImage,
    tags: ["Next.js", "React", "TypeScript", ".NET Core", "MongoDB", "JWT", "Azure"],
    category: "webapp",
  },
  {
    id: 1,
    title: "Custom FizzBuzz Game",
    date: "December 2024 – December 2024",
    description:
      "Engineered a customizable FizzBuzz game engine with a .NET 8 backend and React + Vite frontend. Included live gameplay logic, rule configuration, scoring, and Docker-based deployment for local testing and scalability.",
    image: FizzBuzzImage,
    tags: ["React", "Vite", ".NET 8", "EF Core", "SQLite", "Docker", "TypeScript"],
    category: "webapp",
  },
  {
    id: 2,
    title: "Digital Crafters",
    date: "July 2024 – August 2024",
    description:
      "Developed an interactive platform for a digital solutions business, offering web development services, portfolio showcases, and tailored SaaS solutions for clients.",
    image: DigitalImages,
    tags: ["JavaScript", "React.js", "HTML", "CSS", "Node.js", "Git", "Botpress"],
    category: "website",
    webapp: "https://digital-crafters-website.vercel.app/",
  },
  {
    id: 3,
    title: "Integrated Insurance Solutions",
    date: "May 2024 – June 2024",
    description:
      "Created a responsive and user-friendly platform for an insurance provider, allowing users to explore plans, request quotes, and access essential policy information effortlessly.",
    image: InsuranceImage,
    tags: ["WordPress", "Elementor"],
    category: "website",
    webapp: "https://integratedinsurancesolutions.com.au/",
  },
  {
    id: 4,
    title: "Broadmeadows Place Medical Clinic",
    date: "February 2024 – March 2024",
    description:
      "Designed and built a modern website for a medical clinic, featuring an intuitive appointment booking system, service listings, and essential clinic details to enhance patient engagement.",
    image: BroadmeadowsImage,
    tags: ["WordPress", "Elementor"],
    category: "website",
    webapp: "https://broadmeadowsplacemc.com.au/",
  },
  {
    id: 5,
    title: "DT Security Doors and Shutters",
    date: "December 2023 – January 2024",
    description:
      "Developed a professional website for a security business, showcasing products such as security doors, roller shutters, curtains, and windows. Implemented product galleries, service pages, and a contact form for seamless customer inquiries.",
    image: DTSecurityImage,
    tags: ["React", "JavaScript", "TypeScript", "CSS", "Next.js", "Node.js"],
    category: "website",
    webapp: "https://dtsecuritydoorsandshutters.com.au/",
  },
];